function initTizianoCarousels() {
    function openCartDrawer() {
      var cartToggle = document.querySelector('.cart-drawer-button');
      if (cartToggle) cartToggle.click();
    }

    function updateArrows(root) {
      var header = root.querySelector('.carnav__header');
      var track = root.querySelector('[data-carnav-track]');
      var prev = root.querySelector('[data-carnav-prev]');
      var next = root.querySelector('[data-carnav-next]');
      if (!track || !prev || !next || !header) return;
      var canScroll = track.scrollWidth > track.clientWidth + 4;
      header.classList.toggle('is-not-scrollable', !canScroll);
      var count = root.querySelector('[data-carnav-count]');
      var items = Array.from(track.querySelectorAll('.carnav__item'));
      if (count && items.length) { var closest = items.reduce(function(best,item,i){ return Math.abs(item.offsetLeft-items[0].offsetLeft-track.scrollLeft) < Math.abs(items[best].offsetLeft-items[0].offsetLeft-track.scrollLeft) ? i : best; },0); count.textContent = (closest+1)+' / '+items.length; }
      prev.disabled = !canScroll || track.scrollLeft <= 4;
      next.disabled = !canScroll || track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      if (!canScroll) return;
      prev.classList.toggle('is-disabled', track.scrollLeft <= 4);
      next.classList.toggle('is-disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 4);
    }

    document.querySelectorAll('.carnav').forEach(function (root) {
      if (root.dataset.carnavInit === 'true') return;
      root.dataset.carnavInit = 'true';

      var track = root.querySelector('[data-carnav-track]');
      var prev = root.querySelector('[data-carnav-prev]');
      var next = root.querySelector('[data-carnav-next]');
      if (!track) return;

      updateArrows(root);
      track.addEventListener('scroll', function () {
        updateArrows(root);
      });
      window.addEventListener('resize', function () {
        updateArrows(root);
      });
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          updateArrows(root);
        }).observe(track);
      }

      function stepSize() { var firstItem = track.querySelector('.carnav__item'); return (firstItem ? firstItem.getBoundingClientRect().width : 252) + (parseFloat(getComputedStyle(track).columnGap)||8); }
      function move(direction) { track.scrollBy({left:direction*stepSize()*(matchMedia('(max-width:749px)').matches ? 1 : 2),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}); }

      if (prev) {
        prev.addEventListener('click', function () {
          if (prev.classList.contains('is-disabled')) return;
          move(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          if (next.classList.contains('is-disabled')) return;
          move(1);
        });
      }

      root.querySelectorAll('[data-carnav-quickadd]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          btn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add-to-cart-failed');
              return res.json();
            })
            .then(function () {
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
                    el.textContent = cart.item_count;
                  });
                })
                .catch(function () {});
              openCartDrawer();
              setTimeout(function () {
                btn.classList.remove('is-added');
              }, 1800);
            })
            .catch(function () {
              btn.classList.remove('is-loading');
            });
        });
      });

      root.querySelectorAll('[data-carnav-variant-toggle]').forEach(function (toggleBtn) {
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var wrap = toggleBtn.closest('.carnav__image-wrap');
          var panel = wrap ? wrap.querySelector('[data-carnav-variant-panel]') : null;
          if (!panel) return;
          var wasOpen = panel.classList.contains('is-open');
          root.querySelectorAll('[data-carnav-variant-panel]').forEach(function (p) {
            p.classList.remove('is-open');
          });
          if (!wasOpen) panel.classList.add('is-open');
        });
      });

      root.querySelectorAll('[data-carnav-variant-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          var panel = select.closest('[data-carnav-variant-panel]');
          var priceEl = panel ? panel.querySelector('[data-carnav-variant-price]') : null;
          var option = select.options[select.selectedIndex];
          if (priceEl && option && option.getAttribute('data-price')) {
            priceEl.textContent = option.getAttribute('data-price');
          }
        });
      });

      root.querySelectorAll('[data-carnav-variant-add]').forEach(function (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-added')) return;
          var panel = addBtn.closest('[data-carnav-variant-panel]');
          var select = panel ? panel.querySelector('[data-carnav-variant-select]') : null;
          var variantId = select ? select.value : null;
          if (!variantId) return;
          var originalText = addBtn.textContent;
          addBtn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add-to-cart-failed');
              return res.json();
            })
            .then(function () {
              addBtn.classList.remove('is-loading');
              addBtn.classList.add('is-added');
              addBtn.textContent = 'Hinzugefügt';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
                    el.textContent = cart.item_count;
                  });
                })
                .catch(function () {});
              openCartDrawer();
              setTimeout(function () {
                addBtn.classList.remove('is-added');
                addBtn.textContent = originalText;
                if (panel) panel.classList.remove('is-open');
              }, 1500);
            })
            .catch(function () {
              addBtn.classList.remove('is-loading');
            });
        });
      });
    });

    if (!window.__tzCarnavOutsideClickBound) {
      window.__tzCarnavOutsideClickBound = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.carnav__variant-panel') && !e.target.closest('[data-carnav-variant-toggle]')) {
          document.querySelectorAll('.carnav__variant-panel.is-open').forEach(function (p) {
            p.classList.remove('is-open');
          });
        }
      });
    }
  }
initTizianoCarousels();
if (!window.__tzCarnavSectionBound) { window.__tzCarnavSectionBound = true; document.addEventListener("shopify:section:load", initTizianoCarousels); }

